import { ItemType } from '../type';
import { ComboOption } from '../../../core/component'
import { KeyValuePair } from '../../../core/type'
import { DefaultOptionType } from 'antd/es/select'

const entries = Object.entries({
  [ItemType.Jewelery]: ItemType.Jewelery,
  [ItemType.Watch]: ItemType.Watch,
  [ItemType.Giftware]: ItemType.Giftware,
  [ItemType.Stone]: ItemType.Stone,
  [ItemType.Tableware]: ItemType.Tableware,
})
export const getItemTypeComboOptions = () =>
  entries
    .map<ComboOption<KeyValuePair>>(([key, value]) => ({
      value: key,
      display: value,
      item: {key: key.toString(), value}
    }))

export const getItemTypeSelectOptions = (): DefaultOptionType[] =>
  entries.map(([key, value]) => ({
    label: value,
    value: key,
  }))
